import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const AuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      // Save token to localStorage
      localStorage.setItem("token", token);

      // Redirect to home page
      setTimeout(() => {
        navigate("/home");
      }, 1000);
    } else {
      // If no token, redirect to login
      navigate("/login");
    }
  }, [searchParams, navigate]);

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <h3>Authentication Successful!</h3>
        <p className="text-muted">Redirecting you to the home page...</p>
      </div>
    </div>
  );
};

export default AuthSuccess;
